import { NgModule, Injector, Injectable, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HiveMessageModule } from './hivemessage/hivemessage.module';
import { MobilePhoneHiveMessageComponent } from './hivemessage/components/mobile-phone-hivemessage.component';

// Separate service to handle field registration
@Injectable()
export class FieldRegistrationService {
  constructor(private injector: Injector) {}

  async registerFields(): Promise<void> {
    console.log('FieldRegistrationService: Starting field registration...');

    try {
      const core = await import('core');
      const FieldRegistry = core?.FieldRegistry;

      if (!FieldRegistry) {
        throw new Error('FieldRegistry not found in core module');
      }

      const fieldRegistry = this.injector.get(FieldRegistry);

      if (!fieldRegistry || typeof fieldRegistry.registerField !== 'function') {
        throw new Error('FieldRegistry resolved but registerField is missing');
      }

      console.log('✓ FieldRegistry found! Registering WhatsApp component...');

      const moduleNames = ['contacts', 'leads', 'accounts'];
      const fieldNames = [
        'phone_mobile',
        'phone_work',
        'phone_office',
        'phone_home',
        'phone_other',
        'phone_fax'
      ];

      let registered = false;

      moduleNames.forEach(moduleName => {
        fieldNames.forEach(fieldName => {
          try {
            fieldRegistry.registerField(
              moduleName,
              fieldName,
              'detail',
              MobilePhoneHiveMessageComponent as any
            );
            console.log(`✓ WhatsApp icon registered for ${moduleName}.${fieldName}.detail`);
            registered = true;
          } catch (err) {
            console.debug(`✗ Failed to register ${moduleName}.${fieldName}:`, err);
          }
        });
      });

      if (!registered) {
        throw new Error('No fields were registered - all registrations failed');
      }
    } catch (error) {
      console.error('❌ Field registration failed:', error?.message || error);
      console.error('Error details:', error);
    }
  }
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HiveMessageModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    FieldRegistrationService,
    {
      provide: APP_INITIALIZER,
      useFactory: (registrationService: FieldRegistrationService) => {
        return () => {
          registrationService.registerFields();
        };
      },
      deps: [FieldRegistrationService],
      multi: true
    }
  ]
})
export class ExtensionModule {
  constructor() {
    console.log('HiveMessage extension module ant initialized');
  }
}
